import { posts } from './posts';

export const tagColors: Record<string, string> = {
  'View All': 'primary',
  'Health': 'secondary',
  'Stories': 'accent',
  'Tech & Engineering': 'info',
  'Company News': 'success'
};  

export enum BlogCategoryTags {
  'View All',
  'Health',
  'Stories',
  'Tech & Engineering',
  'Company News',
}

export interface BlogPost {
  id: string;
  image: string;
  // true for cover photos: fills the card image and spans the post page, instead of fitting a small logo
  photo?: boolean;
  tag: string;
  date: string;
  title: string;
  subtitle: string;
  readTime: string;
  content: string;
}

const blogPosts: BlogPost[] = posts;

export default blogPosts;
